module.exports = __webpack_public_path__ + "static/media/VTS.a3c6ea17.jpg";